// Default wheel configuration
// Visual styling and game logic that applies to all wheels
// Text strings should be overridden via i18n or component props

export default {
  // Visual styling
  colorArray: ["#cd0000", "#737373", "#000000", "#737373"],

  // SVG dimensions
  svgWidth: 1024,
  svgHeight: 768,
  wheelSize: 700,
  centerX: 512,
  centerY: 384,

  // Wheel styling
  wheelStrokeColor: "#e9e9e9",
  wheelStrokeWidth: 20,
  wheelTextOffsetY: 105,
  wheelTextColor: "#fff",
  wheelTextSize: "4.3em",
  wheelImageOffsetY: 40,
  wheelImageSize: 50,

  // Center circle
  centerCircleSize: 360,
  centerCircleStrokeColor: "#000",
  centerCircleStrokeWidth: 5,
  centerCircleFillColor: "#EDEDED",
  centerCircleImageUrl: "../img/promotions/logo-wheel.png",
  centerCircleImageWidth: 400,
  centerCircleImageHeight: 400,

  // Segment styling
  segmentStrokeColor: "#fff",
  segmentStrokeWidth: 4,

  // Game logic
  hasShadows: false,
  numSpins: 1,
  spinDestinationArray: [],
  minSpinDuration: 6,
  hasSound: true,
  gameId: "9a0232ec06bc431114e2a7f3aea03bbe2164f1aa",
  clickToSpin: true,
  spinDirection: "cw",

  // Default fallback text (English)
  // These should be overridden via props or i18n
  segmentValuesArray: [
    { probability: 75, type: "string", value: "$100", win: true, resultText: "YOU WON $100 IN FREE PLAY!", userData: { prize: 100 } },
    { probability: 5, type: "string", value: "$50", win: true, resultText: "YOU WON $50 IN FREE PLAY!", userData: { prize: 50 } },
    { probability: 10, type: "string", value: "$20", win: true, resultText: "YOU WON $20 IN FREE PLAY!", userData: { prize: 20 } },
    { probability: 10, type: "string", value: "$10", win: true, resultText: "YOU WON $10 IN FREE PLAY!", userData: { prize: 10 } }
  ],
  gameOverText: "THANK YOU FOR PLAYING SPIN TO WIN!",
  invalidSpinText: "INVALID SPIN. PLEASE SPIN AGAIN.",
  introText: "WIN UP TO<br/>$100 IN FREE PLAY",
  disabledText: "You have no more spins today",

  // UI text (can be overridden per wheel - should be localized at page level)
  modalTitle: "Spin to Win",
  spinButtonText: "Spin",
  closeButtonText: "Close",
  spinsLeftText: "Spins left: {current}/{total}"
};
